import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Typography,
  Box,
  Button,
  Divider,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import kloudLogoWhite from "../../../assets/ks-web-logo.svg";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleCookiePreferences = () => {
    // Termly may not be initialized yet if the script is still loading,
    // so guard before calling — avoids a silent crash in a SPA
    if (typeof window.displayPreferenceModal === "function") {
      window.displayPreferenceModal();
    } else {
      console.warn("Termly preference modal not available yet");
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#2B2E3B",
          color: "#A1A5B2",
          py: 4,
          width: "100%",
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            alignItems="flex-start"
            direction={isMobile ? "column" : "row"}
          >
            {/* Logo */}
            <Grid item xs={12} sm={12} md={3}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-start",
                  mb: isMobile ? 2 : 0,
                }}
              >
                <Box
                  component="img"
                  src={kloudLogoWhite}
                  alt="Kloudscan"
                  sx={{ height: 35, width: "auto" }}
                />
              </Box>
            </Grid>

            {/* Column 1: Company */}
            <Grid item xs={12} sm={6} md={3}>
              <Stack
                spacing={1}
                alignItems={isMobile ? "center" : "flex-start"}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ color: "#ffffff" }}
                >
                  Company
                </Typography>

                <Button component={Link} to="/about" sx={linkStyle}>
                  About Us
                </Button>

                <Button component={Link} to="/privacy-policy" sx={linkStyle}>
                  Privacy Policy
                </Button>

                <Button component={Link} to="/terms-of-use" sx={linkStyle}>
                  Terms of Use
                </Button>

                <Button component={Link} to="/cookie-policy" sx={linkStyle}>
                  Cookie Policy
                </Button>

                <Button component={Link} to="/pricing" sx={linkStyle}>
                  Pricing
                </Button>
              </Stack>
            </Grid>

            {/* Column 2: Resources */}
            <Grid item xs={12} sm={6} md={3}>
              <Stack
                spacing={1}
                alignItems={isMobile ? "center" : "flex-start"}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ color: "#ffffff" }}
                >
                  Resources
                </Typography>

                <Button component={Link} to="/faq" sx={linkStyle}>
                  FAQ
                </Button>

                <Button component={Link} to="/contact" sx={linkStyle}>
                  Contact Us
                </Button>

                <Button
                  component="a"
                  href="https://blog.kloudscan.com"
                  sx={linkStyle}
                >
                  Blog
                </Button>
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3, borderColor: "rgba(255,255,255,0.2)" }} />

          {/* Bottom row */}
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            direction={isMobile ? "column" : "row"}
            spacing={1}
          >
            <Grid item>
              <Stack
                direction="row"
                spacing={2}
                justifyContent={isMobile ? "center" : "flex-end"}
                flexWrap="wrap"
              >
                <Button component={Link} to="/terms-of-use" sx={linkStyle}>
                  Terms of Use
                </Button>

                <Button component={Link} to="/privacy-policy" sx={linkStyle}>
                  Privacy Policy
                </Button>

                <Button component={Link} to="/cookie-policy" sx={linkStyle}>
                  Cookie Policy
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Cookie Preferences Bar */}
      <Box
        sx={{
          backgroundColor: "#171717",
          color: "#ffffff",
          py: 2,
          width: "100%",
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: isMobile ? "center" : "space-between",
              alignItems: "center",
              gap: 2,
              flexWrap: "nowrap",
            }}
          >
            <Typography
              variant="body2"
              align={isMobile ? "center" : "left"}
              sx={{
                color: "rgba(255,255,255,0.7)",
                whiteSpace: "nowrap",
              }}
            >
              &copy; {new Date().getFullYear()} Kloudscan
            </Typography>

            <Button
              onClick={handleCookiePreferences}
              sx={{
                color: "#ffffff",
                fontSize: "0.75rem",
                textTransform: "none",
                px: 0.5,
                minWidth: "auto",
                whiteSpace: "nowrap",
                "&:hover": {
                  color: "#93c5fd",
                },
              }}
            >
              Cookie Preferences
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

const linkStyle = {
  color: "#A1A5B2",
  px: 0,
  textTransform: "none",
  justifyContent: "flex-start",
  "&:hover": {
    color: "#93c5fd",
  },
};

export default Footer;
